// test1675
(1675 && 0);
